import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AddUserToGroupInput = {
  asAdmin: Scalars['Boolean']['input'];
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type Admin = {
  __typename?: 'Admin';
  email: Scalars['String']['output'];
  has2fa: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type AdminTransactionsConnection = {
  __typename?: 'AdminTransactionsConnection';
  nodes: Array<Transaction>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminUsersConnection = {
  __typename?: 'AdminUsersConnection';
  nodes: Array<User>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ApproveSwapInput = {
  swapId: Scalars['String']['input'];
};

export type ApproveWhitelistedAddressInput = {
  id: Scalars['ID']['input'];
  mfaCode?: InputMaybe<Scalars['String']['input']>;
  passkeyApproval?: InputMaybe<Scalars['String']['input']>;
};

export type AssignUserToCompaniesInput = {
  companyIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignUserToCompanyInput = {
  companyId: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  action: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  newData?: Maybe<Scalars['String']['output']>;
  oldData?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AuditLogsConnection = {
  __typename?: 'AuditLogsConnection';
  nodes: Array<AuditLog>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditLogsFilterInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum Chain {
  Bch = 'BCH',
  Bsc = 'BSC',
  Btc = 'BTC',
  Eth = 'ETH',
  Fiat = 'FIAT',
  Ltc = 'LTC',
  Polygon = 'POLYGON',
  Solana = 'SOLANA',
  Tron = 'TRON'
}

export type CompaniesConnection = {
  __typename?: 'CompaniesConnection';
  nodes: Array<Company>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompaniesFilterInput = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hasFunds?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Company = {
  __typename?: 'Company';
  autoApprove: Scalars['Boolean']['output'];
  balance: Scalars['String']['output'];
  company: Scalars['String']['output'];
  depositRiskThreshold: DepositRiskThreshold;
  folder?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  groupImageUrl?: Maybe<Scalars['String']['output']>;
  hasBalance: Scalars['Boolean']['output'];
  hasLpTransfer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  parentCompanyId?: Maybe<Scalars['String']['output']>;
  parentCompanyName?: Maybe<Scalars['String']['output']>;
  tradeType: TradeType;
};

export type CompanyBalance = {
  __typename?: 'CompanyBalance';
  holdings: Array<CompanyHolding>;
  totalUsdValue: Scalars['String']['output'];
};

export type CompanyDocument = {
  __typename?: 'CompanyDocument';
  checked: Scalars['Boolean']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  type: DocumentType;
  updatedAt: Scalars['String']['output'];
};

export type CompanyDocumentsConnection = {
  __typename?: 'CompanyDocumentsConnection';
  nodes: Array<CompanyDocument>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyDocumentsWithFolder = {
  __typename?: 'CompanyDocumentsWithFolder';
  documents: Array<CompanyDocument>;
  folder?: Maybe<Scalars['String']['output']>;
  parentCompany?: Maybe<ParentCompanyInfo>;
};

export type CompanyHolding = {
  __typename?: 'CompanyHolding';
  balance: Scalars['String']['output'];
  mint: Mint;
  usdValue: Scalars['String']['output'];
};

export type CompanyStats = {
  __typename?: 'CompanyStats';
  address?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currentMonthlyVolumes: Scalars['String']['output'];
  director?: Maybe<Scalars['String']['output']>;
  flaggedTransactions: Scalars['Int']['output'];
  previousMonthlyVolumes: Scalars['String']['output'];
  registrationNumber?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export enum CompanyStatus {
  Crypto = 'CRYPTO',
  CryptoAndFiat = 'CRYPTO_AND_FIAT',
  Deactivated = 'DEACTIVATED'
}

export type CompanyWithUpload = {
  __typename?: 'CompanyWithUpload';
  autoApprove: Scalars['Boolean']['output'];
  company: Scalars['String']['output'];
  depositRiskThreshold: DepositRiskThreshold;
  group: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  tradeType: TradeType;
  uploadData?: Maybe<PresignedUploadData>;
};

export type ComplianceOfficer = {
  __typename?: 'ComplianceOfficer';
  created: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ComplianceOfficersConnection = {
  __typename?: 'ComplianceOfficersConnection';
  nodes: Array<ComplianceOfficer>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CreateCompanyInput = {
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  groupId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentCompanyId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompanyStatus>;
};

export type CreateComplianceOfficerInput = {
  email: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateDepositNoteInput = {
  content: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};

export type CreateGroupInput = {
  bps: Scalars['Float']['input'];
  defaultDepositRiskThreshold: DepositRiskThreshold;
  liquidityProviderId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateGroupOwnerInput = {
  email: Scalars['String']['input'];
  groupIds: Array<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type CreateSuperAdminInput = {
  email: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateSwapNoteInput = {
  content: Scalars['String']['input'];
  swapId: Scalars['String']['input'];
};

export type CreateUserInput = {
  companyIds: Array<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  groupIds: Array<Scalars['ID']['input']>;
  isWhitelisted: Scalars['Boolean']['input'];
  username: Scalars['String']['input'];
};

export type CreateWhitelistedAddressInput = {
  address: Scalars['String']['input'];
  chain: Chain;
  companyId: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export enum Currency {
  Bch = 'BCH',
  Bnb = 'BNB',
  Bsc = 'BSC',
  Btc = 'BTC',
  Eth = 'ETH',
  Ltc = 'LTC',
  Pol = 'POL',
  Sol = 'SOL',
  Tron = 'TRON',
  Trx = 'TRX',
  Usdc = 'USDC',
  Usdt = 'USDT'
}

export type CursorPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardStats = {
  __typename?: 'DashboardStats';
  activeCompanies: Scalars['String']['output'];
  availableBalance: Scalars['String']['output'];
  awaitingApprovalDeposits: Scalars['String']['output'];
  awaitingApprovalSwaps: Scalars['String']['output'];
  currentMonthlyVolumes: Scalars['String']['output'];
  flaggedTransactions: Scalars['String']['output'];
  groups: Scalars['String']['output'];
  pendingDeposits: Scalars['String']['output'];
  pendingSwaps: Scalars['String']['output'];
  previousMonthlyVolumes: Scalars['String']['output'];
};

export enum DepositRiskThreshold {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  VeryLow = 'VERY_LOW'
}

export enum DepositStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Initiated = 'INITIATED',
  LpTransferCompleted = 'LP_TRANSFER_COMPLETED',
  LpTransferFailed = 'LP_TRANSFER_FAILED',
  LpTransferInitiated = 'LP_TRANSFER_INITIATED',
  Rejected = 'REJECTED',
  RejectedCompleted = 'REJECTED_COMPLETED',
  RejectedFailed = 'REJECTED_FAILED'
}

export type DepositTransaction = {
  __typename?: 'DepositTransaction';
  amount: Scalars['String']['output'];
  chain: Chain;
  company: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  companyImageUrl?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  decisionBy: Scalars['String']['output'];
  decisionDate: Scalars['String']['output'];
  depositAddress: Scalars['String']['output'];
  depositTransactionHash: Scalars['String']['output'];
  finalizedDate: Scalars['String']['output'];
  group: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  groupImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExternalApi?: Maybe<Scalars['Boolean']['output']>;
  isFlagged: Scalars['Boolean']['output'];
  notes: Array<DepositTransactionNote>;
  rejectTransactionHash?: Maybe<Scalars['String']['output']>;
  status: DepositStatus;
  symbol: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type DepositTransactionNote = {
  __typename?: 'DepositTransactionNote';
  author: Scalars['String']['output'];
  content: Scalars['String']['output'];
  flagged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  role: UserRole;
  timestamp: Scalars['String']['output'];
};

export type DepositTransactionsConnection = {
  __typename?: 'DepositTransactionsConnection';
  nodes: Array<DepositTransaction>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DepositWallet = {
  __typename?: 'DepositWallet';
  address: Scalars['String']['output'];
  currency: Currency;
};

export type DepositWalletsConnection = {
  __typename?: 'DepositWalletsConnection';
  nodes: Array<DepositWallet>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum DocumentType {
  BankStatements = 'BANK_STATEMENTS',
  CertificateOfIncorporation = 'CERTIFICATE_OF_INCORPORATION',
  CompanyProofOfAddress = 'COMPANY_PROOF_OF_ADDRESS',
  DirectorId = 'DIRECTOR_ID',
  DirectorProofOfAddress = 'DIRECTOR_PROOF_OF_ADDRESS',
  InternationalWireTransferInformation = 'INTERNATIONAL_WIRE_TRANSFER_INFORMATION',
  RegistryOfDirectors = 'REGISTRY_OF_DIRECTORS'
}

export type FlagDepositInput = {
  depositId: Scalars['String']['input'];
  flagged: Scalars['Boolean']['input'];
};

export type FlagSwapInput = {
  flagged: Scalars['Boolean']['input'];
  swapId: Scalars['String']['input'];
};

export type GasWallet = {
  __typename?: 'GasWallet';
  address: Scalars['String']['output'];
  balance: Scalars['String']['output'];
  type: Currency;
  usdValue: Scalars['String']['output'];
};

export type GasWalletsConnection = {
  __typename?: 'GasWalletsConnection';
  nodes: Array<GasWallet>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Group = {
  __typename?: 'Group';
  admin: Array<Scalars['String']['output']>;
  bps: Scalars['Float']['output'];
  companies: Scalars['Int']['output'];
  defaultDepositRiskThreshold: DepositRiskThreshold;
  groupId: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  liquidityProvider?: Maybe<Scalars['String']['output']>;
  liquidityProviderBps: Scalars['Float']['output'];
  liquidityProviderId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pendingNotifications: Scalars['Int']['output'];
  status: GroupStatus;
  totalFeeBps: Scalars['Float']['output'];
  usdValueOfAvailableBalance: Scalars['String']['output'];
};

export type GroupStats = {
  __typename?: 'GroupStats';
  activeCompanies: Scalars['Int']['output'];
  availableBalance: Scalars['String']['output'];
  currentMonthlyVolumes: Scalars['String']['output'];
  flaggedTransactions: Scalars['Int']['output'];
  liquidityProvider: Scalars['String']['output'];
  liquidityProviderBps: Scalars['Float']['output'];
  previousMonthlyVolumes: Scalars['String']['output'];
  valiantBps?: Maybe<Scalars['Float']['output']>;
};

export enum GroupStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

export type GroupWithUpload = {
  __typename?: 'GroupWithUpload';
  admin: Array<Scalars['String']['output']>;
  bps: Scalars['Float']['output'];
  companies: Scalars['Int']['output'];
  defaultDepositRiskThreshold: DepositRiskThreshold;
  groupId: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: GroupStatus;
  totalFeeBps: Scalars['Float']['output'];
  uploadData?: Maybe<PresignedUploadData>;
};

export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  nodes: Array<Group>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupsFilterInput = {
  status?: InputMaybe<GroupStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type LiquidityProvider = {
  __typename?: 'LiquidityProvider';
  bps: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  valiantBps?: Maybe<Scalars['Float']['output']>;
};

export type LiquidityProvidersConnection = {
  __typename?: 'LiquidityProvidersConnection';
  nodes: Array<LiquidityProvider>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LpFeeTotal = {
  __typename?: 'LpFeeTotal';
  groupFeeUsd: Scalars['String']['output'];
  lpId: Scalars['ID']['output'];
  lpName: Scalars['String']['output'];
  totalUsd: Scalars['String']['output'];
  totalUsdRaw: Scalars['Float']['output'];
};

export type Mint = {
  __typename?: 'Mint';
  address?: Maybe<Scalars['String']['output']>;
  chain: Chain;
  decimals: Scalars['Int']['output'];
  displayDecimals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type MintLpFee = {
  __typename?: 'MintLpFee';
  fee: Scalars['String']['output'];
  lpId: Scalars['ID']['output'];
  lpName: Scalars['String']['output'];
};

export type MintVolume = {
  __typename?: 'MintVolume';
  groupFee: Scalars['String']['output'];
  lpFee: Scalars['String']['output'];
  lpFees: Array<MintLpFee>;
  mint: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  valiantFee: Scalars['String']['output'];
  volume: Scalars['String']['output'];
};

export type MonthlyVolume = {
  __typename?: 'MonthlyVolume';
  lpFees: Array<LpFeeTotal>;
  mints: Array<MintVolume>;
  month: Scalars['String']['output'];
  totalGroupFeeUsd: Scalars['String']['output'];
  totalGroupFeeUsdRaw: Scalars['Float']['output'];
  totalLpFeeUsd: Scalars['String']['output'];
  totalLpFeeUsdRaw: Scalars['Float']['output'];
  totalUsd: Scalars['String']['output'];
  totalUsdRaw: Scalars['Float']['output'];
  totalValiantFeeUsd: Scalars['String']['output'];
  totalValiantFeeUsdRaw: Scalars['Float']['output'];
};

export type MonthlyVolumesConnection = {
  __typename?: 'MonthlyVolumesConnection';
  nodes: Array<MonthlyVolume>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MonthlyVolumesFilterInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addUserToGroup: User;
  approveDeposit: DepositTransaction;
  approveSwap: Swap;
  approveWhitelistedAddress: WhitelistedAddress;
  assignUserToCompanies: User;
  assignUserToCompany: User;
  createCompany: Company;
  createComplianceOfficer: ComplianceOfficer;
  createDepositNote: DepositTransactionNote;
  createGroup: Group;
  createGroupOwner: User;
  createSuperAdmin: User;
  createSwapNote: SwapNote;
  createUser: User;
  createWhitelistedAddress: WhitelistedAddress;
  flagDeposit: DepositTransaction;
  flagSwap: Swap;
  logout: Scalars['Boolean']['output'];
  reassignCompany: Company;
  refreshGasWallets: Scalars['Boolean']['output'];
  rejectDeposit: DepositTransaction;
  rejectSwap: Swap;
  rejectWhitelistedAddress: WhitelistedAddress;
  removeUserFromCompany: User;
  removeUserFromGroup: User;
  resetMFA: Admin;
  resetPassword: Admin;
  setMaintenanceMode: Scalars['Boolean']['output'];
  updateCompany: UpdateCompanyResult;
  updateCompanyDocument: CompanyDocument;
  updateGroup: UpdateGroupResult;
  updateGroupLiquidityProvider: Group;
  updateUser: User;
  updateWhitelistedAddress: WhitelistedAddress;
};


export type MutationAddUserToGroupArgs = {
  input: AddUserToGroupInput;
};


export type MutationApproveDepositArgs = {
  depositId: Scalars['ID']['input'];
};


export type MutationApproveSwapArgs = {
  input: ApproveSwapInput;
};


export type MutationApproveWhitelistedAddressArgs = {
  input: ApproveWhitelistedAddressInput;
};


export type MutationAssignUserToCompaniesArgs = {
  input: AssignUserToCompaniesInput;
};


export type MutationAssignUserToCompanyArgs = {
  input: AssignUserToCompanyInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateComplianceOfficerArgs = {
  input: CreateComplianceOfficerInput;
};


export type MutationCreateDepositNoteArgs = {
  input: CreateDepositNoteInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateGroupOwnerArgs = {
  input: CreateGroupOwnerInput;
};


export type MutationCreateSuperAdminArgs = {
  input: CreateSuperAdminInput;
};


export type MutationCreateSwapNoteArgs = {
  input: CreateSwapNoteInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateWhitelistedAddressArgs = {
  input: CreateWhitelistedAddressInput;
};


export type MutationFlagDepositArgs = {
  input: FlagDepositInput;
};


export type MutationFlagSwapArgs = {
  input: FlagSwapInput;
};


export type MutationReassignCompanyArgs = {
  input: ReassignCompanyInput;
};


export type MutationRejectDepositArgs = {
  depositId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectSwapArgs = {
  input: RejectSwapInput;
};


export type MutationRejectWhitelistedAddressArgs = {
  input: RejectWhitelistedAddressInput;
};


export type MutationRemoveUserFromCompanyArgs = {
  input: RemoveUserFromCompanyInput;
};


export type MutationRemoveUserFromGroupArgs = {
  input: RemoveUserFromGroupInput;
};


export type MutationResetMfaArgs = {
  userId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSetMaintenanceModeArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyDocumentArgs = {
  input: UpdateCompanyDocumentInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateGroupLiquidityProviderArgs = {
  input: UpdateGroupLiquidityProviderInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateWhitelistedAddressArgs = {
  input: UpdateWhitelistedAddressInput;
};

export type OperationResult = {
  __typename?: 'OperationResult';
  id?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OrgGraph = {
  __typename?: 'OrgGraph';
  nodes: Array<OrgGraphNode>;
};

export type OrgGraphInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrgGraphNode = {
  __typename?: 'OrgGraphNode';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  type: OrgGraphNodeType;
};

export enum OrgGraphNodeType {
  Company = 'COMPANY',
  Group = 'GROUP',
  User = 'USER'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ParentCompanyInfo = {
  __typename?: 'ParentCompanyInfo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PresignedUploadData = {
  __typename?: 'PresignedUploadData';
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getAuditLogs: AuditLogsConnection;
  getCompanies: Array<Company>;
  getCompany: Company;
  getCompanyBalance: CompanyBalance;
  getCompanyDepositWallets: Array<DepositWallet>;
  getCompanyDocuments: CompanyDocumentsWithFolder;
  getCompanyStats: CompanyStats;
  getCompanyWhitelistedAddresses: Array<WhitelistedAddress>;
  getComplianceOfficers: Array<ComplianceOfficer>;
  getDashboardStats: DashboardStats;
  getDepositTransaction?: Maybe<DepositTransaction>;
  getGasWallets: Array<GasWallet>;
  getGroup: Group;
  getGroupStats: GroupStats;
  getGroups: Array<Group>;
  getLiquidityProviders: Array<LiquidityProvider>;
  getMaintenanceMode: Scalars['Boolean']['output'];
  getMe: Admin;
  getMonthlyVolumes: Array<MonthlyVolume>;
  getOrgGraph: OrgGraph;
  getSwap?: Maybe<Swap>;
  getSwaps: SwapsConnection;
  getTransactions: AdminTransactionsConnection;
  getUser?: Maybe<User>;
  getUsers: AdminUsersConnection;
};


export type QueryGetAuditLogsArgs = {
  filter?: InputMaybe<AuditLogsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QueryGetCompaniesArgs = {
  filter?: InputMaybe<CompaniesFilterInput>;
};


export type QueryGetCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCompanyBalanceArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCompanyDepositWalletsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryGetCompanyDocumentsArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCompanyStatsArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCompanyWhitelistedAddressesArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetDepositTransactionArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryGetGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetGroupStatsArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetGroupsArgs = {
  filter?: InputMaybe<GroupsFilterInput>;
};


export type QueryGetMonthlyVolumesArgs = {
  filter?: InputMaybe<MonthlyVolumesFilterInput>;
};


export type QueryGetOrgGraphArgs = {
  input?: InputMaybe<OrgGraphInput>;
};


export type QueryGetSwapArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSwapsArgs = {
  filter?: InputMaybe<SwapsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QueryGetTransactionsArgs = {
  filter?: InputMaybe<TransactionsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QueryGetUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUsersArgs = {
  filter?: InputMaybe<UsersFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type ReassignCompanyInput = {
  companyId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
};

export type RejectSwapInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  swapId: Scalars['String']['input'];
};

export type RejectWhitelistedAddressInput = {
  id: Scalars['ID']['input'];
};

export type RemoveUserFromCompanyInput = {
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveUserFromGroupInput = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type Requester = {
  __typename?: 'Requester';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type SharedTransaction = {
  __typename?: 'SharedTransaction';
  approvedDate?: Maybe<Scalars['String']['output']>;
  company: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['String']['output']>;
  depositStatus?: Maybe<DepositStatus>;
  finalizedDate?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isFlagged: Scalars['Boolean']['output'];
  status: TransactionStatus;
  swapStatus?: Maybe<SwapStatus>;
  transaction: TransactionData;
  type: TransactionType;
  user?: Maybe<Scalars['String']['output']>;
};

export type SharedUser = {
  __typename?: 'SharedUser';
  companiesCount: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  groupsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isWhitelisted: Scalars['Boolean']['output'];
  lastActive?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  username: Scalars['String']['output'];
};

export type Swap = {
  __typename?: 'Swap';
  company: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  companyImageUrl?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  decisionAt?: Maybe<Scalars['String']['output']>;
  decisionBy?: Maybe<Scalars['String']['output']>;
  decisionById?: Maybe<Scalars['String']['output']>;
  fromAmount: Scalars['String']['output'];
  fromMint: Mint;
  group: Scalars['String']['output'];
  groupBps: Scalars['Float']['output'];
  groupId: Scalars['String']['output'];
  groupImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExternalApi?: Maybe<Scalars['Boolean']['output']>;
  isFlagged: Scalars['Boolean']['output'];
  lpFee: Scalars['String']['output'];
  lpId: Scalars['Int']['output'];
  lpReference?: Maybe<Scalars['String']['output']>;
  lpWithdrawalTxHash?: Maybe<Scalars['String']['output']>;
  notes: Array<SwapNote>;
  pushoutWithdrawalTxHash?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<Scalars['String']['output']>;
  requestedById?: Maybe<Scalars['String']['output']>;
  showValiantBps: Scalars['Boolean']['output'];
  status: SwapStatus;
  swapGroupBps: Scalars['Float']['output'];
  swapLpBps: Scalars['Float']['output'];
  swapValiantBps: Scalars['Float']['output'];
  toAmount: Scalars['String']['output'];
  toMint: Mint;
  updatedAt: Scalars['String']['output'];
  usdValue?: Maybe<Scalars['String']['output']>;
  whitelistedAddress: Scalars['String']['output'];
};

export type SwapNote = {
  __typename?: 'SwapNote';
  author: Scalars['String']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: UserRole;
  timestamp: Scalars['String']['output'];
};

export enum SwapStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  PushOutCompleted = 'PUSH_OUT_COMPLETED',
  PushOutFailed = 'PUSH_OUT_FAILED',
  PushOutInitiated = 'PUSH_OUT_INITIATED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  TradeCompleted = 'TRADE_COMPLETED',
  TradeExecuting = 'TRADE_EXECUTING',
  TradeFailed = 'TRADE_FAILED',
  WithdrawalCompleted = 'WITHDRAWAL_COMPLETED',
  WithdrawalFailed = 'WITHDRAWAL_FAILED',
  WithdrawalInitiated = 'WITHDRAWAL_INITIATED'
}

export type SwapsConnection = {
  __typename?: 'SwapsConnection';
  nodes: Array<Swap>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SwapsFilterInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TransactionStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum TradeType {
  Crypto = 'CRYPTO',
  CryptoAndFiat = 'CRYPTO_AND_FIAT',
  Deactivated = 'DEACTIVATED'
}

export type Transaction = {
  __typename?: 'Transaction';
  action?: Maybe<TransactionAction>;
  approvedDate?: Maybe<Scalars['String']['output']>;
  company: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  depositAddress: Scalars['String']['output'];
  depositStatus?: Maybe<DepositStatus>;
  finalizedDate?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  groupBps?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isExternalApi?: Maybe<Scalars['Boolean']['output']>;
  isFlagged: Scalars['Boolean']['output'];
  lpId: Scalars['Int']['output'];
  status: TransactionStatus;
  swapGroupBps?: Maybe<Scalars['Float']['output']>;
  swapLpBps?: Maybe<Scalars['Float']['output']>;
  swapStatus?: Maybe<SwapStatus>;
  swapValiantBps?: Maybe<Scalars['Float']['output']>;
  transaction: TransactionDetails;
  type: TransactionType;
  user: Scalars['String']['output'];
};

export enum TransactionAction {
  Execute = 'EXECUTE',
  Review = 'REVIEW'
}

export type TransactionData = {
  __typename?: 'TransactionData';
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  fromCurrency?: Maybe<Scalars['String']['output']>;
  fromCurrencyImage?: Maybe<Scalars['String']['output']>;
  fromNetwork?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  toCurrency?: Maybe<Scalars['String']['output']>;
  toCurrencyImage?: Maybe<Scalars['String']['output']>;
  toNetwork?: Maybe<Scalars['String']['output']>;
};

export type TransactionDetails = {
  __typename?: 'TransactionDetails';
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
  from?: Maybe<Scalars['String']['output']>;
  fromCurrency?: Maybe<Currency>;
  fromCurrencyImage?: Maybe<Scalars['String']['output']>;
  fromNetwork?: Maybe<Chain>;
  to?: Maybe<Scalars['String']['output']>;
  toCurrency?: Maybe<Currency>;
  toCurrencyImage?: Maybe<Scalars['String']['output']>;
  toNetwork?: Maybe<Chain>;
};

export enum TransactionStatus {
  Approved = 'APPROVED',
  Awaiting = 'AWAITING',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum TransactionType {
  Deposit = 'DEPOSIT',
  Trade = 'TRADE'
}

export type TransactionsConnection = {
  __typename?: 'TransactionsConnection';
  nodes: Array<SharedTransaction>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TransactionsFilterInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TransactionStatus>;
  type?: InputMaybe<TransactionType>;
};

export type UpdateCompanyDocumentInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['String']['input'];
  documentType: DocumentType;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  depositRiskThreshold?: InputMaybe<DepositRiskThreshold>;
  director?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCompanyId?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompanyStatus>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyResult = Company | CompanyWithUpload;

export type UpdateGroupInput = {
  bps?: InputMaybe<Scalars['Float']['input']>;
  defaultDepositRiskThreshold?: InputMaybe<DepositRiskThreshold>;
  groupId: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GroupStatus>;
};

export type UpdateGroupLiquidityProviderInput = {
  groupId: Scalars['String']['input'];
  liquidityProviderId: Scalars['Int']['input'];
};

export type UpdateGroupResult = Group | GroupWithUpload;

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isWhitelisted?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<UserRole>;
  userId: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWhitelistedAddressInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  companiesCount: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  groupsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isWhitelisted: Scalars['Boolean']['output'];
  lastActive: Scalars['String']['output'];
  role: UserRole;
  username: Scalars['String']['output'];
};

export enum UserRole {
  Compliance = 'COMPLIANCE',
  GroupOwner = 'GROUP_OWNER',
  SuperAdmin = 'SUPER_ADMIN',
  Trader = 'TRADER'
}

export type UsersConnection = {
  __typename?: 'UsersConnection';
  nodes: Array<SharedUser>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UsersFilterInput = {
  adminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  excludeGroupId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type WhitelistedAddress = {
  __typename?: 'WhitelistedAddress';
  address: Scalars['String']['output'];
  chain: Chain;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  decisionBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  requester?: Maybe<Requester>;
  status: WhitelistedAddressStatus;
  updatedAt: Scalars['String']['output'];
};

export enum WhitelistedAddressStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type WhitelistedAddressesConnection = {
  __typename?: 'WhitelistedAddressesConnection';
  nodes: Array<WhitelistedAddress>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', getMe: { __typename?: 'Admin', username: string, email: string, has2fa: boolean } };

export type GetMaintenanceModeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaintenanceModeQuery = { __typename?: 'Query', getMaintenanceMode: boolean };

export type SetMaintenanceModeMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type SetMaintenanceModeMutation = { __typename?: 'Mutation', setMaintenanceMode: boolean };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type ResetPasswordMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'Admin', userId: string, username: string, email: string } };

export type ResetMfaMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ResetMfaMutation = { __typename?: 'Mutation', resetMFA: { __typename?: 'Admin', userId: string, username: string, email: string } };

export type GetDashboardStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardStatsQuery = { __typename?: 'Query', getDashboardStats: { __typename?: 'DashboardStats', activeCompanies: string, availableBalance: string, groups: string, flaggedTransactions: string, currentMonthlyVolumes: string, previousMonthlyVolumes: string, pendingSwaps: string, pendingDeposits: string, awaitingApprovalSwaps: string, awaitingApprovalDeposits: string } };

export type GetGroupsQueryVariables = Exact<{
  filter?: InputMaybe<GroupsFilterInput>;
}>;


export type GetGroupsQuery = { __typename?: 'Query', getGroups: Array<{ __typename?: 'Group', name: string, status: GroupStatus, admin: Array<string>, companies: number, groupId: string, bps: number, totalFeeBps: number, liquidityProviderBps: number, imageUrl?: string | null, usdValueOfAvailableBalance: string }> };

export type GetGroupQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GetGroupQuery = { __typename?: 'Query', getGroup: { __typename?: 'Group', name: string, status: GroupStatus, admin: Array<string>, companies: number, groupId: string, bps: number, totalFeeBps: number, defaultDepositRiskThreshold: DepositRiskThreshold, imageUrl?: string | null, liquidityProvider?: string | null, liquidityProviderId?: string | null, usdValueOfAvailableBalance: string } };

export type GetGroupStatsQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GetGroupStatsQuery = { __typename?: 'Query', getGroupStats: { __typename?: 'GroupStats', activeCompanies: number, availableBalance: string, flaggedTransactions: number, currentMonthlyVolumes: string, previousMonthlyVolumes: string, liquidityProvider: string, liquidityProviderBps: number, valiantBps?: number | null } };

export type GetCompanyStatsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyStatsQuery = { __typename?: 'Query', getCompanyStats: { __typename?: 'CompanyStats', flaggedTransactions: number, currentMonthlyVolumes: string, previousMonthlyVolumes: string, registrationNumber?: string | null, director?: string | null, country?: string | null, address?: string | null, website?: string | null } };

export type GetCompanyQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', getCompany: { __typename?: 'Company', id: string, company: string, group: string, groupId: string, groupImageUrl?: string | null, tradeType: TradeType, imageUrl?: string | null, autoApprove: boolean, depositRiskThreshold: DepositRiskThreshold, parentCompanyId?: string | null, parentCompanyName?: string | null } };

export type GetCompanyBalanceQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyBalanceQuery = { __typename?: 'Query', getCompanyBalance: { __typename?: 'CompanyBalance', totalUsdValue: string, holdings: Array<{ __typename?: 'CompanyHolding', balance: string, usdValue: string, mint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null } }> } };

export type GetCompaniesQueryVariables = Exact<{
  filter?: InputMaybe<CompaniesFilterInput>;
}>;


export type GetCompaniesQuery = { __typename?: 'Query', getCompanies: Array<{ __typename?: 'Company', id: string, company: string, group: string, groupId: string, tradeType: TradeType, imageUrl?: string | null, autoApprove: boolean, balance: string, parentCompanyId?: string | null }> };

export type GetComplianceOfficersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetComplianceOfficersQuery = { __typename?: 'Query', getComplianceOfficers: Array<{ __typename?: 'ComplianceOfficer', id: string, name: string, email: string, created: string }> };

export type GetUsersQueryVariables = Exact<{
  filter?: InputMaybe<UsersFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsers: { __typename?: 'AdminUsersConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, username: string, email: string, lastActive: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', id: string, username: string, email: string, lastActive: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } | null };

export type GetTransactionsQueryVariables = Exact<{
  filter?: InputMaybe<TransactionsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type GetTransactionsQuery = { __typename?: 'Query', getTransactions: { __typename?: 'AdminTransactionsConnection', totalCount: number, nodes: Array<{ __typename?: 'Transaction', id: string, company: string, group: string, user: string, type: TransactionType, status: TransactionStatus, depositStatus?: DepositStatus | null, swapStatus?: SwapStatus | null, groupBps?: number | null, swapGroupBps?: number | null, swapLpBps?: number | null, swapValiantBps?: number | null, lpId: number, createdDate: string, approvedDate?: string | null, finalizedDate?: string | null, depositAddress: string, action?: TransactionAction | null, isFlagged: boolean, isExternalApi?: boolean | null, transaction: { __typename?: 'TransactionDetails', from?: string | null, fromCurrency?: Currency | null, fromNetwork?: Chain | null, fromCurrencyImage?: string | null, to?: string | null, toCurrency?: Currency | null, toCurrencyImage?: string | null, amount?: string | null, currency?: Currency | null, toNetwork?: Chain | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetDepositTransactionQueryVariables = Exact<{
  transactionId: Scalars['String']['input'];
}>;


export type GetDepositTransactionQuery = { __typename?: 'Query', getDepositTransaction?: { __typename?: 'DepositTransaction', id: string, status: DepositStatus, type: string, currency: string, symbol: string, chain: Chain, amount: string, user: string, company: string, companyId: string, companyImageUrl?: string | null, group: string, groupId: string, groupImageUrl?: string | null, decisionBy: string, transactionId: string, creationDate: string, decisionDate: string, finalizedDate: string, depositTransactionHash: string, rejectTransactionHash?: string | null, depositAddress: string, isFlagged: boolean, isExternalApi?: boolean | null, notes: Array<{ __typename?: 'DepositTransactionNote', id: string, author: string, role: UserRole, timestamp: string, content: string, flagged: boolean }> } | null };

export type FlagDepositMutationVariables = Exact<{
  input: FlagDepositInput;
}>;


export type FlagDepositMutation = { __typename?: 'Mutation', flagDeposit: { __typename?: 'DepositTransaction', id: string, status: DepositStatus, type: string, currency: string, symbol: string, chain: Chain, amount: string, user: string, company: string, companyId: string, group: string, groupId: string, decisionBy: string, transactionId: string, creationDate: string, decisionDate: string, finalizedDate: string, depositTransactionHash: string, depositAddress: string, isFlagged: boolean, notes: Array<{ __typename?: 'DepositTransactionNote', id: string, author: string, role: UserRole, timestamp: string, content: string, flagged: boolean }> } };

export type FlagSwapMutationVariables = Exact<{
  input: FlagSwapInput;
}>;


export type FlagSwapMutation = { __typename?: 'Mutation', flagSwap: { __typename?: 'Swap', id: string, companyId: string, company: string, group: string, requestedById?: string | null, requestedBy?: string | null, decisionById?: string | null, decisionBy?: string | null, fromAmount: string, toAmount: string, lpFee: string, usdValue?: string | null, status: SwapStatus, lpReference?: string | null, lpWithdrawalTxHash?: string | null, pushoutWithdrawalTxHash?: string | null, createdAt: string, updatedAt: string, decisionAt?: string | null, completedAt?: string | null, whitelistedAddress: string, isFlagged: boolean, fromMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, address?: string | null, chain: Chain, image?: string | null }, toMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, address?: string | null, chain: Chain, image?: string | null }, notes: Array<{ __typename?: 'SwapNote', id: string, author: string, role: UserRole, timestamp: string, content: string }> } };

export type ApproveDepositMutationVariables = Exact<{
  depositId: Scalars['ID']['input'];
}>;


export type ApproveDepositMutation = { __typename?: 'Mutation', approveDeposit: { __typename?: 'DepositTransaction', id: string, status: DepositStatus, type: string, currency: string, symbol: string, chain: Chain, amount: string, user: string, company: string, companyId: string, group: string, groupId: string, decisionBy: string, transactionId: string, creationDate: string, decisionDate: string, finalizedDate: string, depositTransactionHash: string, depositAddress: string, isFlagged: boolean, notes: Array<{ __typename?: 'DepositTransactionNote', id: string, author: string, role: UserRole, timestamp: string, content: string, flagged: boolean }> } };

export type RejectDepositMutationVariables = Exact<{
  depositId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectDepositMutation = { __typename?: 'Mutation', rejectDeposit: { __typename?: 'DepositTransaction', id: string, status: DepositStatus, type: string, currency: string, symbol: string, chain: Chain, amount: string, user: string, company: string, companyId: string, group: string, groupId: string, decisionBy: string, transactionId: string, creationDate: string, decisionDate: string, finalizedDate: string, depositTransactionHash: string, depositAddress: string, isFlagged: boolean, notes: Array<{ __typename?: 'DepositTransactionNote', id: string, author: string, role: UserRole, timestamp: string, content: string, flagged: boolean }> } };

export type GetGasWalletsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGasWalletsQuery = { __typename?: 'Query', getGasWallets: Array<{ __typename?: 'GasWallet', type: Currency, address: string, balance: string, usdValue: string }> };

export type RefreshGasWalletsMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshGasWalletsMutation = { __typename?: 'Mutation', refreshGasWallets: boolean };

export type GetMonthlyVolumesQueryVariables = Exact<{
  filter?: InputMaybe<MonthlyVolumesFilterInput>;
}>;


export type GetMonthlyVolumesQuery = { __typename?: 'Query', getMonthlyVolumes: Array<{ __typename?: 'MonthlyVolume', month: string, totalUsd: string, totalUsdRaw: number, totalGroupFeeUsd: string, totalGroupFeeUsdRaw: number, totalLpFeeUsd: string, totalLpFeeUsdRaw: number, mints: Array<{ __typename?: 'MintVolume', mint: string, symbol: string, volume: string, groupFee: string, lpFee: string, lpFees: Array<{ __typename?: 'MintLpFee', lpId: string, lpName: string, fee: string }> }>, lpFees: Array<{ __typename?: 'LpFeeTotal', lpId: string, lpName: string, totalUsd: string, totalUsdRaw: number, groupFeeUsd: string }> }> };

export type GetLiquidityProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLiquidityProvidersQuery = { __typename?: 'Query', getLiquidityProviders: Array<{ __typename?: 'LiquidityProvider', id: string, name: string, bps: number, valiantBps?: number | null }> };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', name: string, status: GroupStatus, admin: Array<string>, companies: number, groupId: string, bps: number, totalFeeBps: number, defaultDepositRiskThreshold: DepositRiskThreshold } };

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'Group', name: string, status: GroupStatus, admin: Array<string>, companies: number, groupId: string, bps: number, totalFeeBps: number, defaultDepositRiskThreshold: DepositRiskThreshold, imageUrl?: string | null } | { __typename?: 'GroupWithUpload', name: string, status: GroupStatus, admin: Array<string>, companies: number, groupId: string, bps: number, totalFeeBps: number, defaultDepositRiskThreshold: DepositRiskThreshold, imageUrl?: string | null, uploadData?: { __typename?: 'PresignedUploadData', uploadUrl: string, fileUrl: string, fileName: string } | null } };

export type UpdateGroupLiquidityProviderMutationVariables = Exact<{
  input: UpdateGroupLiquidityProviderInput;
}>;


export type UpdateGroupLiquidityProviderMutation = { __typename?: 'Mutation', updateGroupLiquidityProvider: { __typename?: 'Group', name: string, status: GroupStatus, admin: Array<string>, companies: number, groupId: string, bps: number, totalFeeBps: number } };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', id: string, company: string, group: string, tradeType: TradeType } };

export type CreateComplianceOfficerMutationVariables = Exact<{
  input: CreateComplianceOfficerInput;
}>;


export type CreateComplianceOfficerMutation = { __typename?: 'Mutation', createComplianceOfficer: { __typename?: 'ComplianceOfficer', id: string, name: string, email: string, created: string } };

export type CreateGroupOwnerMutationVariables = Exact<{
  input: CreateGroupOwnerInput;
}>;


export type CreateGroupOwnerMutation = { __typename?: 'Mutation', createGroupOwner: { __typename?: 'User', id: string, username: string, email: string, lastActive: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number } };

export type CreateSuperAdminMutationVariables = Exact<{
  input: CreateSuperAdminInput;
}>;


export type CreateSuperAdminMutation = { __typename?: 'Mutation', createSuperAdmin: { __typename?: 'User', id: string, username: string, email: string, lastActive: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number } };

export type AddUserToGroupMutationVariables = Exact<{
  input: AddUserToGroupInput;
}>;


export type AddUserToGroupMutation = { __typename?: 'Mutation', addUserToGroup: { __typename?: 'User', id: string, username: string, email: string, lastActive: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number } };

export type RemoveUserFromGroupMutationVariables = Exact<{
  input: RemoveUserFromGroupInput;
}>;


export type RemoveUserFromGroupMutation = { __typename?: 'Mutation', removeUserFromGroup: { __typename?: 'User', id: string, username: string, email: string, lastActive: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };

export type RemoveUserFromCompanyMutationVariables = Exact<{
  input: RemoveUserFromCompanyInput;
}>;


export type RemoveUserFromCompanyMutation = { __typename?: 'Mutation', removeUserFromCompany: { __typename?: 'User', id: string, username: string, email: string, lastActive: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };

export type AssignUserToCompanyMutationVariables = Exact<{
  input: AssignUserToCompanyInput;
}>;


export type AssignUserToCompanyMutation = { __typename?: 'Mutation', assignUserToCompany: { __typename?: 'User', id: string, username: string, email: string, lastActive: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };

export type AssignUserToCompaniesMutationVariables = Exact<{
  input: AssignUserToCompaniesInput;
}>;


export type AssignUserToCompaniesMutation = { __typename?: 'Mutation', assignUserToCompanies: { __typename?: 'User', id: string, username: string, email: string, lastActive: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, username: string, email: string, lastActive: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, username: string, email: string, lastActive: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };

export type GetCompanyDepositWalletsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type GetCompanyDepositWalletsQuery = { __typename?: 'Query', getCompanyDepositWallets: Array<{ __typename?: 'DepositWallet', currency: Currency, address: string }> };

export type GetCompanyWhitelistedAddressesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyWhitelistedAddressesQuery = { __typename?: 'Query', getCompanyWhitelistedAddresses: Array<{ __typename?: 'WhitelistedAddress', id: string, companyId: string, chain: Chain, address: string, label?: string | null, status: WhitelistedAddressStatus, createdAt: string, updatedAt: string, decisionBy?: string | null, requester?: { __typename?: 'Requester', id: string, username: string, email: string } | null }> };

export type ApproveWhitelistedAddressMutationVariables = Exact<{
  input: ApproveWhitelistedAddressInput;
}>;


export type ApproveWhitelistedAddressMutation = { __typename?: 'Mutation', approveWhitelistedAddress: { __typename?: 'WhitelistedAddress', id: string, companyId: string, chain: Chain, address: string, label?: string | null, status: WhitelistedAddressStatus, createdAt: string, updatedAt: string, decisionBy?: string | null } };

export type RejectWhitelistedAddressMutationVariables = Exact<{
  input: RejectWhitelistedAddressInput;
}>;


export type RejectWhitelistedAddressMutation = { __typename?: 'Mutation', rejectWhitelistedAddress: { __typename?: 'WhitelistedAddress', id: string, companyId: string, chain: Chain, address: string, label?: string | null, status: WhitelistedAddressStatus, createdAt: string, updatedAt: string, decisionBy?: string | null } };

export type UpdateWhitelistedAddressMutationVariables = Exact<{
  input: UpdateWhitelistedAddressInput;
}>;


export type UpdateWhitelistedAddressMutation = { __typename?: 'Mutation', updateWhitelistedAddress: { __typename?: 'WhitelistedAddress', id: string, companyId: string, chain: Chain, address: string, label?: string | null, status: WhitelistedAddressStatus, createdAt: string, updatedAt: string } };

export type CreateWhitelistedAddressMutationVariables = Exact<{
  input: CreateWhitelistedAddressInput;
}>;


export type CreateWhitelistedAddressMutation = { __typename?: 'Mutation', createWhitelistedAddress: { __typename?: 'WhitelistedAddress', id: string, companyId: string, chain: Chain, address: string, label?: string | null, status: WhitelistedAddressStatus, createdAt: string, updatedAt: string } };

export type ReassignCompanyMutationVariables = Exact<{
  input: ReassignCompanyInput;
}>;


export type ReassignCompanyMutation = { __typename?: 'Mutation', reassignCompany: { __typename?: 'Company', id: string, company: string, group: string, groupId: string, tradeType: TradeType } };

export type GetAuditLogsQueryVariables = Exact<{
  filter?: InputMaybe<AuditLogsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type GetAuditLogsQuery = { __typename?: 'Query', getAuditLogs: { __typename?: 'AuditLogsConnection', totalCount: number, nodes: Array<{ __typename?: 'AuditLog', id: string, userId?: string | null, user?: string | null, action: string, entityId: string, oldData?: string | null, newData?: string | null, companyName?: string | null, ipAddress?: string | null, userAgent?: string | null, createdAt: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetSwapsQueryVariables = Exact<{
  filter?: InputMaybe<SwapsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type GetSwapsQuery = { __typename?: 'Query', getSwaps: { __typename?: 'SwapsConnection', totalCount: number, nodes: Array<{ __typename?: 'Swap', id: string, companyId: string, company: string, group: string, requestedById?: string | null, requestedBy?: string | null, decisionById?: string | null, decisionBy?: string | null, fromAmount: string, toAmount: string, lpFee: string, groupBps: number, swapGroupBps: number, swapLpBps: number, swapValiantBps: number, showValiantBps: boolean, lpId: number, usdValue?: string | null, status: SwapStatus, lpReference?: string | null, lpWithdrawalTxHash?: string | null, pushoutWithdrawalTxHash?: string | null, createdAt: string, updatedAt: string, decisionAt?: string | null, completedAt?: string | null, whitelistedAddress: string, isFlagged: boolean, isExternalApi?: boolean | null, fromMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null }, toMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ApproveSwapMutationVariables = Exact<{
  input: ApproveSwapInput;
}>;


export type ApproveSwapMutation = { __typename?: 'Mutation', approveSwap: { __typename?: 'Swap', id: string, companyId: string, company: string, group: string, requestedById?: string | null, requestedBy?: string | null, decisionById?: string | null, decisionBy?: string | null, fromAmount: string, toAmount: string, lpFee: string, usdValue?: string | null, status: SwapStatus, lpReference?: string | null, lpWithdrawalTxHash?: string | null, pushoutWithdrawalTxHash?: string | null, createdAt: string, updatedAt: string, decisionAt?: string | null, completedAt?: string | null, whitelistedAddress: string, isFlagged: boolean, fromMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null }, toMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null } } };

export type RejectSwapMutationVariables = Exact<{
  input: RejectSwapInput;
}>;


export type RejectSwapMutation = { __typename?: 'Mutation', rejectSwap: { __typename?: 'Swap', id: string, companyId: string, company: string, group: string, requestedById?: string | null, requestedBy?: string | null, decisionById?: string | null, decisionBy?: string | null, fromAmount: string, toAmount: string, lpFee: string, usdValue?: string | null, status: SwapStatus, lpReference?: string | null, lpWithdrawalTxHash?: string | null, pushoutWithdrawalTxHash?: string | null, createdAt: string, updatedAt: string, decisionAt?: string | null, completedAt?: string | null, whitelistedAddress: string, isFlagged: boolean, fromMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null }, toMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null } } };

export type GetSwapTransactionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSwapTransactionQuery = { __typename?: 'Query', getSwap?: { __typename?: 'Swap', id: string, companyId: string, company: string, companyImageUrl?: string | null, groupId: string, group: string, groupImageUrl?: string | null, requestedById?: string | null, requestedBy?: string | null, decisionById?: string | null, decisionBy?: string | null, fromAmount: string, toAmount: string, lpFee: string, groupBps: number, swapGroupBps: number, swapLpBps: number, swapValiantBps: number, showValiantBps: boolean, usdValue?: string | null, status: SwapStatus, lpReference?: string | null, lpWithdrawalTxHash?: string | null, pushoutWithdrawalTxHash?: string | null, createdAt: string, updatedAt: string, decisionAt?: string | null, completedAt?: string | null, whitelistedAddress: string, isFlagged: boolean, isExternalApi?: boolean | null, fromMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null }, toMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null }, notes: Array<{ __typename?: 'SwapNote', id: string, author: string, role: UserRole, timestamp: string, content: string }> } | null };

export type CreateDepositNoteMutationVariables = Exact<{
  input: CreateDepositNoteInput;
}>;


export type CreateDepositNoteMutation = { __typename?: 'Mutation', createDepositNote: { __typename?: 'DepositTransactionNote', id: string, author: string, role: UserRole, timestamp: string, content: string, flagged: boolean } };

export type CreateSwapNoteMutationVariables = Exact<{
  input: CreateSwapNoteInput;
}>;


export type CreateSwapNoteMutation = { __typename?: 'Mutation', createSwapNote: { __typename?: 'SwapNote', id: string, author: string, role: UserRole, timestamp: string, content: string } };

export type GetCompanyDocumentsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyDocumentsQuery = { __typename?: 'Query', getCompanyDocuments: { __typename?: 'CompanyDocumentsWithFolder', folder?: string | null, parentCompany?: { __typename?: 'ParentCompanyInfo', id: string, name: string } | null, documents: Array<{ __typename?: 'CompanyDocument', id: string, companyId: string, type: DocumentType, link: string, checked: boolean, createdAt: string, updatedAt: string }> } };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: string, company: string, group: string, groupId: string, tradeType: TradeType, imageUrl?: string | null, autoApprove: boolean, depositRiskThreshold: DepositRiskThreshold } | { __typename?: 'CompanyWithUpload', id: string, company: string, group: string, groupId: string, tradeType: TradeType, imageUrl?: string | null, autoApprove: boolean, depositRiskThreshold: DepositRiskThreshold, uploadData?: { __typename?: 'PresignedUploadData', uploadUrl: string, fileUrl: string, fileName: string } | null } };

export type UpdateCompanyDocumentMutationVariables = Exact<{
  input: UpdateCompanyDocumentInput;
}>;


export type UpdateCompanyDocumentMutation = { __typename?: 'Mutation', updateCompanyDocument: { __typename?: 'CompanyDocument', id: string, companyId: string, type: DocumentType, link: string, checked: boolean, createdAt: string, updatedAt: string } };

export type GetOrgGraphQueryVariables = Exact<{
  input?: InputMaybe<OrgGraphInput>;
}>;


export type GetOrgGraphQuery = { __typename?: 'Query', getOrgGraph: { __typename?: 'OrgGraph', nodes: Array<{ __typename?: 'OrgGraphNode', id: string, name: string, parentId?: string | null, type: OrgGraphNodeType }> } };


export const GetMeDocument = gql`
    query getMe {
  getMe {
    username
    email
    has2fa
  }
}
    `;

export function useGetMeQuery(options?: Omit<Urql.UseQueryArgs<GetMeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMeQuery, GetMeQueryVariables>({ query: GetMeDocument, ...options });
};
export const GetMaintenanceModeDocument = gql`
    query GetMaintenanceMode {
  getMaintenanceMode
}
    `;

export function useGetMaintenanceModeQuery(options?: Omit<Urql.UseQueryArgs<GetMaintenanceModeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMaintenanceModeQuery, GetMaintenanceModeQueryVariables>({ query: GetMaintenanceModeDocument, ...options });
};
export const SetMaintenanceModeDocument = gql`
    mutation SetMaintenanceMode($enabled: Boolean!) {
  setMaintenanceMode(enabled: $enabled)
}
    `;

export function useSetMaintenanceModeMutation() {
  return Urql.useMutation<SetMaintenanceModeMutation, SetMaintenanceModeMutationVariables>(SetMaintenanceModeDocument);
};
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const ResetPasswordDocument = gql`
    mutation ResetPassword($userId: String!) {
  resetPassword(userId: $userId) {
    userId
    username
    email
  }
}
    `;

export function useResetPasswordMutation() {
  return Urql.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument);
};
export const ResetMfaDocument = gql`
    mutation ResetMFA($userId: String!) {
  resetMFA(userId: $userId) {
    userId
    username
    email
  }
}
    `;

export function useResetMfaMutation() {
  return Urql.useMutation<ResetMfaMutation, ResetMfaMutationVariables>(ResetMfaDocument);
};
export const GetDashboardStatsDocument = gql`
    query GetDashboardStats {
  getDashboardStats {
    activeCompanies
    availableBalance
    groups
    flaggedTransactions
    currentMonthlyVolumes
    previousMonthlyVolumes
    pendingSwaps
    pendingDeposits
    awaitingApprovalSwaps
    awaitingApprovalDeposits
  }
}
    `;

export function useGetDashboardStatsQuery(options?: Omit<Urql.UseQueryArgs<GetDashboardStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>({ query: GetDashboardStatsDocument, ...options });
};
export const GetGroupsDocument = gql`
    query GetGroups($filter: GroupsFilterInput) {
  getGroups(filter: $filter) {
    name
    status
    admin
    companies
    groupId
    bps
    totalFeeBps
    liquidityProviderBps
    imageUrl
    usdValueOfAvailableBalance
  }
}
    `;

export function useGetGroupsQuery(options?: Omit<Urql.UseQueryArgs<GetGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGroupsQuery, GetGroupsQueryVariables>({ query: GetGroupsDocument, ...options });
};
export const GetGroupDocument = gql`
    query GetGroup($groupId: String!) {
  getGroup(groupId: $groupId) {
    name
    status
    admin
    companies
    groupId
    bps
    totalFeeBps
    defaultDepositRiskThreshold
    imageUrl
    liquidityProvider
    liquidityProviderId
    usdValueOfAvailableBalance
  }
}
    `;

export function useGetGroupQuery(options: Omit<Urql.UseQueryArgs<GetGroupQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGroupQuery, GetGroupQueryVariables>({ query: GetGroupDocument, ...options });
};
export const GetGroupStatsDocument = gql`
    query GetGroupStats($groupId: String!) {
  getGroupStats(groupId: $groupId) {
    activeCompanies
    availableBalance
    flaggedTransactions
    currentMonthlyVolumes
    previousMonthlyVolumes
    liquidityProvider
    liquidityProviderBps
    valiantBps
  }
}
    `;

export function useGetGroupStatsQuery(options: Omit<Urql.UseQueryArgs<GetGroupStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGroupStatsQuery, GetGroupStatsQueryVariables>({ query: GetGroupStatsDocument, ...options });
};
export const GetCompanyStatsDocument = gql`
    query GetCompanyStats($companyId: String!) {
  getCompanyStats(companyId: $companyId) {
    flaggedTransactions
    currentMonthlyVolumes
    previousMonthlyVolumes
    registrationNumber
    director
    country
    address
    website
  }
}
    `;

export function useGetCompanyStatsQuery(options: Omit<Urql.UseQueryArgs<GetCompanyStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyStatsQuery, GetCompanyStatsQueryVariables>({ query: GetCompanyStatsDocument, ...options });
};
export const GetCompanyDocument = gql`
    query GetCompany($companyId: String!) {
  getCompany(companyId: $companyId) {
    id
    company
    group
    groupId
    groupImageUrl
    tradeType
    imageUrl
    autoApprove
    depositRiskThreshold
    parentCompanyId
    parentCompanyName
  }
}
    `;

export function useGetCompanyQuery(options: Omit<Urql.UseQueryArgs<GetCompanyQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyQuery, GetCompanyQueryVariables>({ query: GetCompanyDocument, ...options });
};
export const GetCompanyBalanceDocument = gql`
    query getCompanyBalance($companyId: String!) {
  getCompanyBalance(companyId: $companyId) {
    totalUsdValue
    holdings {
      mint {
        id
        name
        symbol
        decimals
        displayDecimals
        address
        chain
        image
      }
      balance
      usdValue
    }
  }
}
    `;

export function useGetCompanyBalanceQuery(options: Omit<Urql.UseQueryArgs<GetCompanyBalanceQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyBalanceQuery, GetCompanyBalanceQueryVariables>({ query: GetCompanyBalanceDocument, ...options });
};
export const GetCompaniesDocument = gql`
    query GetCompanies($filter: CompaniesFilterInput) {
  getCompanies(filter: $filter) {
    id
    company
    group
    groupId
    tradeType
    imageUrl
    autoApprove
    balance
    parentCompanyId
  }
}
    `;

export function useGetCompaniesQuery(options?: Omit<Urql.UseQueryArgs<GetCompaniesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>({ query: GetCompaniesDocument, ...options });
};
export const GetComplianceOfficersDocument = gql`
    query GetComplianceOfficers {
  getComplianceOfficers {
    id
    name
    email
    created
  }
}
    `;

export function useGetComplianceOfficersQuery(options?: Omit<Urql.UseQueryArgs<GetComplianceOfficersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetComplianceOfficersQuery, GetComplianceOfficersQueryVariables>({ query: GetComplianceOfficersDocument, ...options });
};
export const GetUsersDocument = gql`
    query GetUsers($filter: UsersFilterInput, $pagination: CursorPaginationInput) {
  getUsers(filter: $filter, pagination: $pagination) {
    nodes {
      id
      username
      email
      lastActive
      role
      isActive
      isWhitelisted
      companiesCount
      groupsCount
      emailNotifications
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export function useGetUsersQuery(options?: Omit<Urql.UseQueryArgs<GetUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersQuery, GetUsersQueryVariables>({ query: GetUsersDocument, ...options });
};
export const GetUserDocument = gql`
    query GetUser($userId: String!) {
  getUser(userId: $userId) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useGetUserQuery(options: Omit<Urql.UseQueryArgs<GetUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserQuery, GetUserQueryVariables>({ query: GetUserDocument, ...options });
};
export const GetTransactionsDocument = gql`
    query GetTransactions($filter: TransactionsFilterInput, $pagination: CursorPaginationInput) {
  getTransactions(filter: $filter, pagination: $pagination) {
    nodes {
      id
      company
      group
      user
      type
      transaction {
        from
        fromCurrency
        fromNetwork
        fromCurrencyImage
        to
        toCurrency
        toCurrencyImage
        amount
        currency
        toNetwork
      }
      status
      depositStatus
      swapStatus
      groupBps
      swapGroupBps
      swapLpBps
      swapValiantBps
      lpId
      createdDate
      approvedDate
      finalizedDate
      depositAddress
      action
      isFlagged
      isExternalApi
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export function useGetTransactionsQuery(options?: Omit<Urql.UseQueryArgs<GetTransactionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTransactionsQuery, GetTransactionsQueryVariables>({ query: GetTransactionsDocument, ...options });
};
export const GetDepositTransactionDocument = gql`
    query GetDepositTransaction($transactionId: String!) {
  getDepositTransaction(transactionId: $transactionId) {
    id
    status
    type
    currency
    symbol
    chain
    amount
    user
    company
    companyId
    companyImageUrl
    group
    groupId
    groupImageUrl
    decisionBy
    transactionId
    creationDate
    decisionDate
    finalizedDate
    depositTransactionHash
    rejectTransactionHash
    depositAddress
    notes {
      id
      author
      role
      timestamp
      content
      flagged
    }
    isFlagged
    isExternalApi
  }
}
    `;

export function useGetDepositTransactionQuery(options: Omit<Urql.UseQueryArgs<GetDepositTransactionQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDepositTransactionQuery, GetDepositTransactionQueryVariables>({ query: GetDepositTransactionDocument, ...options });
};
export const FlagDepositDocument = gql`
    mutation FlagDeposit($input: FlagDepositInput!) {
  flagDeposit(input: $input) {
    id
    status
    type
    currency
    symbol
    chain
    amount
    user
    company
    companyId
    group
    groupId
    decisionBy
    transactionId
    creationDate
    decisionDate
    finalizedDate
    depositTransactionHash
    depositAddress
    notes {
      id
      author
      role
      timestamp
      content
      flagged
    }
    isFlagged
  }
}
    `;

export function useFlagDepositMutation() {
  return Urql.useMutation<FlagDepositMutation, FlagDepositMutationVariables>(FlagDepositDocument);
};
export const FlagSwapDocument = gql`
    mutation FlagSwap($input: FlagSwapInput!) {
  flagSwap(input: $input) {
    id
    companyId
    company
    group
    requestedById
    requestedBy
    decisionById
    decisionBy
    fromMint {
      id
      name
      symbol
      decimals
      address
      chain
      image
    }
    toMint {
      id
      name
      symbol
      decimals
      address
      chain
      image
    }
    fromAmount
    toAmount
    lpFee
    usdValue
    status
    lpReference
    lpWithdrawalTxHash
    pushoutWithdrawalTxHash
    createdAt
    updatedAt
    decisionAt
    completedAt
    whitelistedAddress
    isFlagged
    notes {
      id
      author
      role
      timestamp
      content
    }
  }
}
    `;

export function useFlagSwapMutation() {
  return Urql.useMutation<FlagSwapMutation, FlagSwapMutationVariables>(FlagSwapDocument);
};
export const ApproveDepositDocument = gql`
    mutation ApproveDeposit($depositId: ID!) {
  approveDeposit(depositId: $depositId) {
    id
    status
    type
    currency
    symbol
    chain
    amount
    user
    company
    companyId
    group
    groupId
    decisionBy
    transactionId
    creationDate
    decisionDate
    finalizedDate
    depositTransactionHash
    depositAddress
    notes {
      id
      author
      role
      timestamp
      content
      flagged
    }
    isFlagged
  }
}
    `;

export function useApproveDepositMutation() {
  return Urql.useMutation<ApproveDepositMutation, ApproveDepositMutationVariables>(ApproveDepositDocument);
};
export const RejectDepositDocument = gql`
    mutation RejectDeposit($depositId: ID!, $reason: String) {
  rejectDeposit(depositId: $depositId, reason: $reason) {
    id
    status
    type
    currency
    symbol
    chain
    amount
    user
    company
    companyId
    group
    groupId
    decisionBy
    transactionId
    creationDate
    decisionDate
    finalizedDate
    depositTransactionHash
    depositAddress
    notes {
      id
      author
      role
      timestamp
      content
      flagged
    }
    isFlagged
  }
}
    `;

export function useRejectDepositMutation() {
  return Urql.useMutation<RejectDepositMutation, RejectDepositMutationVariables>(RejectDepositDocument);
};
export const GetGasWalletsDocument = gql`
    query GetGasWallets {
  getGasWallets {
    type
    address
    balance
    usdValue
  }
}
    `;

export function useGetGasWalletsQuery(options?: Omit<Urql.UseQueryArgs<GetGasWalletsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGasWalletsQuery, GetGasWalletsQueryVariables>({ query: GetGasWalletsDocument, ...options });
};
export const RefreshGasWalletsDocument = gql`
    mutation RefreshGasWallets {
  refreshGasWallets
}
    `;

export function useRefreshGasWalletsMutation() {
  return Urql.useMutation<RefreshGasWalletsMutation, RefreshGasWalletsMutationVariables>(RefreshGasWalletsDocument);
};
export const GetMonthlyVolumesDocument = gql`
    query GetMonthlyVolumes($filter: MonthlyVolumesFilterInput) {
  getMonthlyVolumes(filter: $filter) {
    month
    mints {
      mint
      symbol
      volume
      groupFee
      lpFee
      lpFees {
        lpId
        lpName
        fee
      }
    }
    totalUsd
    totalUsdRaw
    totalGroupFeeUsd
    totalGroupFeeUsdRaw
    totalLpFeeUsd
    totalLpFeeUsdRaw
    lpFees {
      lpId
      lpName
      totalUsd
      totalUsdRaw
      groupFeeUsd
    }
  }
}
    `;

export function useGetMonthlyVolumesQuery(options?: Omit<Urql.UseQueryArgs<GetMonthlyVolumesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMonthlyVolumesQuery, GetMonthlyVolumesQueryVariables>({ query: GetMonthlyVolumesDocument, ...options });
};
export const GetLiquidityProvidersDocument = gql`
    query GetLiquidityProviders {
  getLiquidityProviders {
    id
    name
    bps
    valiantBps
  }
}
    `;

export function useGetLiquidityProvidersQuery(options?: Omit<Urql.UseQueryArgs<GetLiquidityProvidersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLiquidityProvidersQuery, GetLiquidityProvidersQueryVariables>({ query: GetLiquidityProvidersDocument, ...options });
};
export const CreateGroupDocument = gql`
    mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    name
    status
    admin
    companies
    groupId
    bps
    totalFeeBps
    defaultDepositRiskThreshold
  }
}
    `;

export function useCreateGroupMutation() {
  return Urql.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument);
};
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($input: UpdateGroupInput!) {
  updateGroup(input: $input) {
    ... on Group {
      name
      status
      admin
      companies
      groupId
      bps
      totalFeeBps
      defaultDepositRiskThreshold
      imageUrl
    }
    ... on GroupWithUpload {
      name
      status
      admin
      companies
      groupId
      bps
      totalFeeBps
      defaultDepositRiskThreshold
      imageUrl
      uploadData {
        uploadUrl
        fileUrl
        fileName
      }
    }
  }
}
    `;

export function useUpdateGroupMutation() {
  return Urql.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument);
};
export const UpdateGroupLiquidityProviderDocument = gql`
    mutation UpdateGroupLiquidityProvider($input: UpdateGroupLiquidityProviderInput!) {
  updateGroupLiquidityProvider(input: $input) {
    name
    status
    admin
    companies
    groupId
    bps
    totalFeeBps
  }
}
    `;

export function useUpdateGroupLiquidityProviderMutation() {
  return Urql.useMutation<UpdateGroupLiquidityProviderMutation, UpdateGroupLiquidityProviderMutationVariables>(UpdateGroupLiquidityProviderDocument);
};
export const CreateCompanyDocument = gql`
    mutation CreateCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    id
    company
    group
    tradeType
  }
}
    `;

export function useCreateCompanyMutation() {
  return Urql.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument);
};
export const CreateComplianceOfficerDocument = gql`
    mutation CreateComplianceOfficer($input: CreateComplianceOfficerInput!) {
  createComplianceOfficer(input: $input) {
    id
    name
    email
    created
  }
}
    `;

export function useCreateComplianceOfficerMutation() {
  return Urql.useMutation<CreateComplianceOfficerMutation, CreateComplianceOfficerMutationVariables>(CreateComplianceOfficerDocument);
};
export const CreateGroupOwnerDocument = gql`
    mutation CreateGroupOwner($input: CreateGroupOwnerInput!) {
  createGroupOwner(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
  }
}
    `;

export function useCreateGroupOwnerMutation() {
  return Urql.useMutation<CreateGroupOwnerMutation, CreateGroupOwnerMutationVariables>(CreateGroupOwnerDocument);
};
export const CreateSuperAdminDocument = gql`
    mutation CreateSuperAdmin($input: CreateSuperAdminInput!) {
  createSuperAdmin(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
  }
}
    `;

export function useCreateSuperAdminMutation() {
  return Urql.useMutation<CreateSuperAdminMutation, CreateSuperAdminMutationVariables>(CreateSuperAdminDocument);
};
export const AddUserToGroupDocument = gql`
    mutation AddUserToGroup($input: AddUserToGroupInput!) {
  addUserToGroup(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
  }
}
    `;

export function useAddUserToGroupMutation() {
  return Urql.useMutation<AddUserToGroupMutation, AddUserToGroupMutationVariables>(AddUserToGroupDocument);
};
export const RemoveUserFromGroupDocument = gql`
    mutation RemoveUserFromGroup($input: RemoveUserFromGroupInput!) {
  removeUserFromGroup(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useRemoveUserFromGroupMutation() {
  return Urql.useMutation<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>(RemoveUserFromGroupDocument);
};
export const RemoveUserFromCompanyDocument = gql`
    mutation RemoveUserFromCompany($input: RemoveUserFromCompanyInput!) {
  removeUserFromCompany(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useRemoveUserFromCompanyMutation() {
  return Urql.useMutation<RemoveUserFromCompanyMutation, RemoveUserFromCompanyMutationVariables>(RemoveUserFromCompanyDocument);
};
export const AssignUserToCompanyDocument = gql`
    mutation AssignUserToCompany($input: AssignUserToCompanyInput!) {
  assignUserToCompany(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useAssignUserToCompanyMutation() {
  return Urql.useMutation<AssignUserToCompanyMutation, AssignUserToCompanyMutationVariables>(AssignUserToCompanyDocument);
};
export const AssignUserToCompaniesDocument = gql`
    mutation AssignUserToCompanies($input: AssignUserToCompaniesInput!) {
  assignUserToCompanies(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useAssignUserToCompaniesMutation() {
  return Urql.useMutation<AssignUserToCompaniesMutation, AssignUserToCompaniesMutationVariables>(AssignUserToCompaniesDocument);
};
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
  }
}
    `;

export function useCreateUserMutation() {
  return Urql.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument);
};
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useUpdateUserMutation() {
  return Urql.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument);
};
export const GetCompanyDepositWalletsDocument = gql`
    query GetCompanyDepositWallets($companyId: ID!) {
  getCompanyDepositWallets(companyId: $companyId) {
    currency
    address
  }
}
    `;

export function useGetCompanyDepositWalletsQuery(options: Omit<Urql.UseQueryArgs<GetCompanyDepositWalletsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyDepositWalletsQuery, GetCompanyDepositWalletsQueryVariables>({ query: GetCompanyDepositWalletsDocument, ...options });
};
export const GetCompanyWhitelistedAddressesDocument = gql`
    query GetCompanyWhitelistedAddresses($companyId: String!) {
  getCompanyWhitelistedAddresses(companyId: $companyId) {
    id
    companyId
    chain
    address
    label
    status
    createdAt
    updatedAt
    decisionBy
    requester {
      id
      username
      email
    }
  }
}
    `;

export function useGetCompanyWhitelistedAddressesQuery(options: Omit<Urql.UseQueryArgs<GetCompanyWhitelistedAddressesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyWhitelistedAddressesQuery, GetCompanyWhitelistedAddressesQueryVariables>({ query: GetCompanyWhitelistedAddressesDocument, ...options });
};
export const ApproveWhitelistedAddressDocument = gql`
    mutation ApproveWhitelistedAddress($input: ApproveWhitelistedAddressInput!) {
  approveWhitelistedAddress(input: $input) {
    id
    companyId
    chain
    address
    label
    status
    createdAt
    updatedAt
    decisionBy
  }
}
    `;

export function useApproveWhitelistedAddressMutation() {
  return Urql.useMutation<ApproveWhitelistedAddressMutation, ApproveWhitelistedAddressMutationVariables>(ApproveWhitelistedAddressDocument);
};
export const RejectWhitelistedAddressDocument = gql`
    mutation RejectWhitelistedAddress($input: RejectWhitelistedAddressInput!) {
  rejectWhitelistedAddress(input: $input) {
    id
    companyId
    chain
    address
    label
    status
    createdAt
    updatedAt
    decisionBy
  }
}
    `;

export function useRejectWhitelistedAddressMutation() {
  return Urql.useMutation<RejectWhitelistedAddressMutation, RejectWhitelistedAddressMutationVariables>(RejectWhitelistedAddressDocument);
};
export const UpdateWhitelistedAddressDocument = gql`
    mutation UpdateWhitelistedAddress($input: UpdateWhitelistedAddressInput!) {
  updateWhitelistedAddress(input: $input) {
    id
    companyId
    chain
    address
    label
    status
    createdAt
    updatedAt
  }
}
    `;

export function useUpdateWhitelistedAddressMutation() {
  return Urql.useMutation<UpdateWhitelistedAddressMutation, UpdateWhitelistedAddressMutationVariables>(UpdateWhitelistedAddressDocument);
};
export const CreateWhitelistedAddressDocument = gql`
    mutation CreateWhitelistedAddress($input: CreateWhitelistedAddressInput!) {
  createWhitelistedAddress(input: $input) {
    id
    companyId
    chain
    address
    label
    status
    createdAt
    updatedAt
  }
}
    `;

export function useCreateWhitelistedAddressMutation() {
  return Urql.useMutation<CreateWhitelistedAddressMutation, CreateWhitelistedAddressMutationVariables>(CreateWhitelistedAddressDocument);
};
export const ReassignCompanyDocument = gql`
    mutation ReassignCompany($input: ReassignCompanyInput!) {
  reassignCompany(input: $input) {
    id
    company
    group
    groupId
    tradeType
  }
}
    `;

export function useReassignCompanyMutation() {
  return Urql.useMutation<ReassignCompanyMutation, ReassignCompanyMutationVariables>(ReassignCompanyDocument);
};
export const GetAuditLogsDocument = gql`
    query GetAuditLogs($filter: AuditLogsFilterInput, $pagination: CursorPaginationInput) {
  getAuditLogs(filter: $filter, pagination: $pagination) {
    nodes {
      id
      userId
      user
      action
      entityId
      oldData
      newData
      companyName
      ipAddress
      userAgent
      createdAt
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export function useGetAuditLogsQuery(options?: Omit<Urql.UseQueryArgs<GetAuditLogsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>({ query: GetAuditLogsDocument, ...options });
};
export const GetSwapsDocument = gql`
    query GetSwaps($filter: SwapsFilterInput, $pagination: CursorPaginationInput) {
  getSwaps(filter: $filter, pagination: $pagination) {
    nodes {
      id
      companyId
      company
      group
      requestedById
      requestedBy
      decisionById
      decisionBy
      fromMint {
        id
        name
        symbol
        decimals
        displayDecimals
        address
        chain
        image
      }
      toMint {
        id
        name
        symbol
        decimals
        displayDecimals
        address
        chain
        image
      }
      fromAmount
      toAmount
      lpFee
      groupBps
      swapGroupBps
      swapLpBps
      swapValiantBps
      showValiantBps
      lpId
      usdValue
      status
      lpReference
      lpWithdrawalTxHash
      pushoutWithdrawalTxHash
      createdAt
      updatedAt
      decisionAt
      completedAt
      whitelistedAddress
      isFlagged
      isExternalApi
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export function useGetSwapsQuery(options?: Omit<Urql.UseQueryArgs<GetSwapsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSwapsQuery, GetSwapsQueryVariables>({ query: GetSwapsDocument, ...options });
};
export const ApproveSwapDocument = gql`
    mutation ApproveSwap($input: ApproveSwapInput!) {
  approveSwap(input: $input) {
    id
    companyId
    company
    group
    requestedById
    requestedBy
    decisionById
    decisionBy
    fromMint {
      id
      name
      symbol
      decimals
      displayDecimals
      address
      chain
      image
    }
    toMint {
      id
      name
      symbol
      decimals
      displayDecimals
      address
      chain
      image
    }
    fromAmount
    toAmount
    lpFee
    usdValue
    status
    lpReference
    lpWithdrawalTxHash
    pushoutWithdrawalTxHash
    createdAt
    updatedAt
    decisionAt
    completedAt
    whitelistedAddress
    isFlagged
  }
}
    `;

export function useApproveSwapMutation() {
  return Urql.useMutation<ApproveSwapMutation, ApproveSwapMutationVariables>(ApproveSwapDocument);
};
export const RejectSwapDocument = gql`
    mutation RejectSwap($input: RejectSwapInput!) {
  rejectSwap(input: $input) {
    id
    companyId
    company
    group
    requestedById
    requestedBy
    decisionById
    decisionBy
    fromMint {
      id
      name
      symbol
      decimals
      displayDecimals
      address
      chain
      image
    }
    toMint {
      id
      name
      symbol
      decimals
      displayDecimals
      address
      chain
      image
    }
    fromAmount
    toAmount
    lpFee
    usdValue
    status
    lpReference
    lpWithdrawalTxHash
    pushoutWithdrawalTxHash
    createdAt
    updatedAt
    decisionAt
    completedAt
    whitelistedAddress
    isFlagged
  }
}
    `;

export function useRejectSwapMutation() {
  return Urql.useMutation<RejectSwapMutation, RejectSwapMutationVariables>(RejectSwapDocument);
};
export const GetSwapTransactionDocument = gql`
    query GetSwapTransaction($id: ID!) {
  getSwap(id: $id) {
    id
    companyId
    company
    companyImageUrl
    groupId
    group
    groupImageUrl
    requestedById
    requestedBy
    decisionById
    decisionBy
    fromMint {
      id
      name
      symbol
      decimals
      displayDecimals
      address
      chain
      image
    }
    toMint {
      id
      name
      symbol
      decimals
      displayDecimals
      address
      chain
      image
    }
    fromAmount
    toAmount
    lpFee
    groupBps
    swapGroupBps
    swapLpBps
    swapValiantBps
    showValiantBps
    usdValue
    status
    lpReference
    lpWithdrawalTxHash
    pushoutWithdrawalTxHash
    createdAt
    updatedAt
    decisionAt
    completedAt
    whitelistedAddress
    isFlagged
    isExternalApi
    notes {
      id
      author
      role
      timestamp
      content
    }
  }
}
    `;

export function useGetSwapTransactionQuery(options: Omit<Urql.UseQueryArgs<GetSwapTransactionQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSwapTransactionQuery, GetSwapTransactionQueryVariables>({ query: GetSwapTransactionDocument, ...options });
};
export const CreateDepositNoteDocument = gql`
    mutation CreateDepositNote($input: CreateDepositNoteInput!) {
  createDepositNote(input: $input) {
    id
    author
    role
    timestamp
    content
    flagged
  }
}
    `;

export function useCreateDepositNoteMutation() {
  return Urql.useMutation<CreateDepositNoteMutation, CreateDepositNoteMutationVariables>(CreateDepositNoteDocument);
};
export const CreateSwapNoteDocument = gql`
    mutation CreateSwapNote($input: CreateSwapNoteInput!) {
  createSwapNote(input: $input) {
    id
    author
    role
    timestamp
    content
  }
}
    `;

export function useCreateSwapNoteMutation() {
  return Urql.useMutation<CreateSwapNoteMutation, CreateSwapNoteMutationVariables>(CreateSwapNoteDocument);
};
export const GetCompanyDocumentsDocument = gql`
    query GetCompanyDocuments($companyId: String!) {
  getCompanyDocuments(companyId: $companyId) {
    folder
    parentCompany {
      id
      name
    }
    documents {
      id
      companyId
      type
      link
      checked
      createdAt
      updatedAt
    }
  }
}
    `;

export function useGetCompanyDocumentsQuery(options: Omit<Urql.UseQueryArgs<GetCompanyDocumentsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyDocumentsQuery, GetCompanyDocumentsQueryVariables>({ query: GetCompanyDocumentsDocument, ...options });
};
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    ... on Company {
      id
      company
      group
      groupId
      tradeType
      imageUrl
      autoApprove
      depositRiskThreshold
    }
    ... on CompanyWithUpload {
      id
      company
      group
      groupId
      tradeType
      imageUrl
      autoApprove
      depositRiskThreshold
      uploadData {
        uploadUrl
        fileUrl
        fileName
      }
    }
  }
}
    `;

export function useUpdateCompanyMutation() {
  return Urql.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument);
};
export const UpdateCompanyDocumentDocument = gql`
    mutation UpdateCompanyDocument($input: UpdateCompanyDocumentInput!) {
  updateCompanyDocument(input: $input) {
    id
    companyId
    type
    link
    checked
    createdAt
    updatedAt
  }
}
    `;

export function useUpdateCompanyDocumentMutation() {
  return Urql.useMutation<UpdateCompanyDocumentMutation, UpdateCompanyDocumentMutationVariables>(UpdateCompanyDocumentDocument);
};
export const GetOrgGraphDocument = gql`
    query GetOrgGraph($input: OrgGraphInput) {
  getOrgGraph(input: $input) {
    nodes {
      id
      name
      parentId
      type
    }
  }
}
    `;

export function useGetOrgGraphQuery(options?: Omit<Urql.UseQueryArgs<GetOrgGraphQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrgGraphQuery, GetOrgGraphQueryVariables>({ query: GetOrgGraphDocument, ...options });
};